<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">广告资源-视频</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="popNewAddPic">新增资源</el-button>
            <el-button style="float: right;margin-left:10px;" type="danger" @click="popRemovePic">删除视频</el-button>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column 
                    type="selection" 
                    header-align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="code"
                    header-align="center"
                    min-width="80"
                    label="编号">
                </el-table-column>
                <el-table-column
                    prop="type"
                    header-align="center"
                    min-width="80"
                    label="类型">
                </el-table-column>
                <el-table-column
                    prop="link"
                    header-align="center"
                    min-width="295"
                    label="链接" v-if="false">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="295"
                    label="链接">
                    <template scope="scope">
                        <el-popover
                          ref="popoverPayStatus1"
                          placement="right-start"
                          trigger="hover">
                          <video controls="controls" style="max-width:200px;margin-top: 6px;">
                            <source :src="scope.row.link">
                            该浏览器不支持视频播放
                          </video>
                      </el-popover>
                      <a style="color: #337ab7;text-decoration: none;" v-popover:popoverPayStatus1 :href="scope.row.link" target="_blank">{{scope.row.link}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="title"
                    header-align="center"
                    min-width="120"
                    label="标题">
                </el-table-column>
                <el-table-column
                    prop="content"
                    header-align="center"
                    min-width="95"
                    label="内容">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    header-align="center"
                    min-width="155"
                    label="创建时间">
                </el-table-column>
            </el-table>
        </div>
        <div class="table_pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
            </el-pagination>
        </div>
      </el-card>
      <po-add-video :add-show="addPicShow" :cur-type="curType" @closeAddAccount="closeAddPic"></po-add-video>
    </div>
</template>

<script>
import $axios from '../../https/config'
import poNewAddVideo from '@/page/adMgr/adNewAddResourse'

export default {
  data () {
    return {
      pageSize: 10,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      addPicShow: false,
      curType: 1,
      pageTotal: 0,
      multipleSelection: ''
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList()
  },
  methods: {
    queryDeviceList (tPageNo, tPageSize) {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: 'VIDEO'
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/device/getAdResourcesList', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                code: itemData.id,
                link: itemData.url,
                type: itemData.type,
                title: itemData.title,
                content: itemData.content,
                createTime: itemData.create_time
              }
              resData.push(item)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList()
    },
    handleSelectionChange (selection) {
      this.multipleSelection = ''
      for (var i = 0; i < selection.length; i++) {
        this.multipleSelection += (selection[i].code + '|')
      }
    },
    popNewAddPic (row) {
      this.curType = 1
      this.addPicShow = true
    },
    closeAddPic () {
      this.addPicShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    popRemovePic () {
      var that = this
      if (that.multipleSelection.length === 0) {
        that.$message({
          message: '请选择要回收的资源',
          type: 'info'
        })
        return false
      }
      var params = {
        adIds: that.multipleSelection
      }
      that.$confirm('您已选择广告的ID：' + that.multipleSelection, '是否删除选中的视频', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/device/delAdResources', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.queryDeviceList()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
          }
        }, function () {
          that.$message({
            type: 'error',
            message: '删除失败!'
          })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  components: {
    'po-add-video': poNewAddVideo
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
</style>


// WEBPACK FOOTER //
// src/page/adMgr/adVideo.vue